/* =============================================================
 * import
 * ========================================================== */
import {gsap} from "gsap/gsap-core";
import {CustomEase} from "gsap/CustomEase";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import Swiper from 'swiper/bundle';
import {generateCalendar} from "../modules/fullcalendar";
// import {mediaQuery} from "../modules/common";

gsap.registerPlugin(CustomEase, ScrollTrigger);
CustomEase.create("slide", ".32, .95, .6, 1");

/* =============================================================
 * function
 * ========================================================== */
let swiper;

export default function exe(data) {
  const namespace = data.current.namespace; // barbajsからdataを取得

  // 遷移元ページが存在しない場合（TOPページにランディングした場合）のみ実行
  if (namespace === '') {
    console.log('landing');
  }

  bannerSwiper();
  generateCalendar(data);

  window.addEventListener('resize', function() {
    bannerSwiper();
  });

}


function bannerSwiper() {

  // const cursor = document.getElementById("cursor");
  const swipeContent = document.querySelector('.swiper');
  // const windowWidth = window.innerWidth;

  if (swipeContent) {

    const initSwiper = () => {
      swiper = new Swiper('.swiper', { // eslint-disable-line @typescript-eslint/no-unused-vars
        slidesPerView: 'auto', // コンテナ内に表示させるスライド数（CSSでサイズ指定する場合は 'auto'）
        speed: 1200, // スライドアニメーションのスピード（ミリ秒）
        initialSlide: 1, // スライドの開始位置
        centeredSlides: true,
        loop: true,  // 無限ループさせる
        loopAdditionalSlides: 2, // 無限ループさせる場合に複製するスライド数
        grabCursor: true, // PCでマウスカーソルを「掴む」マークにする
        watchSlidesProgress: false, // スライドの進行状況を監視する / 重くなるので使わない場合はfalse推奨
        preventClicks: true, // true: スワイプ中の不要なクリックを無効化
        preventClicksPropagation: true, // true: スワイプ中の不要なクリックイベントを無効化
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        autoplay: {
          delay: 3000,  // 自動再生の間隔
          pauseOnMouseEnter: true, // マウスを乗せている間は自動再生を止める（true）
          disableOnInteraction: false,  // 一度でも操作すると自動再生を止める（true）
        },
        freeMode: {
          enabled: true, // true：自由にドラッグ（スワイプ）できるようにする。
          momentum: true, // 有効にすると、スライドを離した後もしばらくの間、スライドが動き続けます
          momentumRatio: 1, // 数字が大きいほど惰性スクロールの距離が伸びる（freeMode: trueとfreeModeMomentum:trueが前提）
          momentumVelocityRatio: 1, // 数字が大きいほど惰性スクロールのスピードが速くなる（freeMode: trueとfreeModeMomentum:trueが前提）
          sticky: false,  // スライド位置へのスナップの有効無効
        },
        mousewheel: {
          forceToAxis: true,
        },

        /*
        on: {
          progress: function () {
            rotateSlider(this);
          },
          init: function () {
            updateCustomClasses(this);
          },
          slideChange: function () {
            updateCustomClasses(this);
          },
        },
        */
      });

      /*
      swipeContent.addEventListener("mouseenter", function() {
        cursor.classList.add('active_swipe');
      });

      swipeContent.addEventListener("mouseleave", function() {
        cursor.classList.remove('active_swipe');
      });
      */
    };


    const destroySwiper = () => {
      if (swiper && typeof swiper.destroy === 'function') {
        swiper.destroy();
        swiper = null;
        // cursor.classList.remove('active_swipe');
      }
    };

    const handleSwiper = () => {
      destroySwiper();

      if (!swiper) {
        initSwiper();
      }
    };

    handleSwiper();

  }
}


